"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueArc = void 0;
const react_1 = __importStar(require("react"));
const base_react_components_1 = require("@navinc/base-react-components");
const styled_components_1 = __importStar(require("styled-components"));
const in_range_1 = __importDefault(require("../../utils/in-range"));
const dash = (0, styled_components_1.keyframes) `
    to {
        stroke-dashoffset: 0;
    }
`;
const arcFlow = (0, styled_components_1.keyframes) `
  from {
    motion-offset: 0%; /* For Clover Station (Chrome 52) support */
    offset-distance: 0%;
  }
  to {
    motion-offset: 100%; /* For Clover Station (Chrome 52) support */
    offset-distance: 100%;
  }
`;
const Knob = styled_components_1.default.circle.withConfig({ displayName: "reports-Knob", componentId: "reports-yony0e" }) `
  ${({ arcPath }) => `
  motion-path: path('${arcPath}'); /* For Clover Station (Chrome 52) support */
  offset-path: path('${arcPath}');
  motion-offset: 0%; /* For Clover Station (Chrome 52) support */
  offset-distance: 0%;
  `}

  animation: ${arcFlow} 2s forwards;
`;
const ArcPathLine = styled_components_1.default.path.withConfig({ displayName: "reports-ArcPathLine", componentId: "reports-tlf5k7" }) `
  stroke-dasharray: ${({ lineLength }) => `${lineLength}`};
  stroke-dashoffset: ${({ lineLength }) => `${lineLength}`};
  animation: ${dash} 2s forwards;
`;
const deg2Rads = (deg) => deg * (Math.PI / 180);
const arcEnd = (deg, radius) => {
    const theta = deg2Rads(180 - deg);
    return {
        x: radius + (Math.cos(theta) * radius + Math.sin(theta) * 0),
        y: -Math.sin(theta) * radius + Math.cos(theta) * 0,
    };
};
const ArcBase = ({ degrees = 180, thickness = 8, color = 'currentcolor', lineCap = 'round', radius = 100, offsetX = 10, offsetY = 15, vHeight = 100, }) => {
    const { x, y } = arcEnd(degrees, radius);
    return (react_1.default.createElement("path", { d: `M ${offsetX} ${vHeight - offsetY} a ${radius} ${radius}, 0, 0, 1, ${x} ${y}`, stroke: color, strokeWidth: thickness, strokeLinecap: lineCap, fill: "none" }));
};
const ArcFill = ({ degrees = 180, thickness = 8, color = 'currentcolor', lineCap = 'round', radius = 100, offsetX = 10, offsetY = 15, vHeight = 100, }) => {
    const { x, y } = arcEnd(degrees, radius);
    const [lineLength, setLineLength] = (0, react_1.useState)(0);
    const arcPathLineRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a, _b, _c;
        if (arcPathLineRef.current) {
            setLineLength((_c = (_b = (_a = arcPathLineRef.current) === null || _a === void 0 ? void 0 : _a.getTotalLength) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : 0);
        }
    }, []);
    return (react_1.default.createElement(ArcPathLine, { "data-testid": "arcPathLine", ref: arcPathLineRef, d: `M ${offsetX} ${vHeight - offsetY} a ${radius} ${radius}, 0, 0, 1, ${x} ${y}`, stroke: color, strokeWidth: thickness, strokeLinecap: lineCap, fill: "none", lineLength: lineLength }));
};
const ArcKnob = ({ degrees = 180, thickness = 8, color = 'currentcolor', lineCap = 'round', radius = 100, offsetX = 10, offsetY = 15, vHeight = 100, }) => {
    const { x, y } = arcEnd(degrees, radius);
    return (react_1.default.createElement(Knob, { r: 10, fill: "white", stroke: color, strokeWidth: thickness, strokeLinecap: lineCap, "data-testid": "arc-knob", arcPath: `M ${offsetX} ${vHeight - offsetY} a ${radius} ${radius}, 0, 0, 1, ${x} ${y}` }));
};
const ArcReactor = styled_components_1.default.div.withConfig({ displayName: "reports-ArcReactor", componentId: "reports-42hcv8" }) `
  svg {
    margin: 0 -10px;
  }
`;
const ArcWrapper = styled_components_1.default.div.withConfig({ displayName: "reports-ArcWrapper", componentId: "reports-l81pqh" }) `
  display: flex;
  justify-content: space-between;
  ${({ $labelsBelow }) => $labelsBelow && 'flex-wrap: wrap;'}
`;
const Min = (0, styled_components_1.default)(base_react_components_1.Copy).withConfig({ displayName: "reports-Min", componentId: "reports-16hyrnz" }) `
  flex-grow: 1;
  align-self: flex-end;
  min-width: 35px;
  ${({ $labelsBelow }) => $labelsBelow && 'order: 1;'}
`;
const ArcSVG = styled_components_1.default.svg.withConfig({ displayName: "reports-ArcSVG", componentId: "reports-f29nfu" }) `
  color: ${({ status, $displayValues = {} }) => $displayValues.color || base_react_components_1.theme[status] || 'transparent'};
  flex-grow: 50;
`;
const Max = (0, styled_components_1.default)(base_react_components_1.Copy).withConfig({ displayName: "reports-Max", componentId: "reports-1jbftze" }) `
  flex-grow: 1;
  align-self: flex-end;
  text-align: right;
  min-width: 35px;
  ${({ $labelsBelow }) => $labelsBelow && 'order: 1;'}
`;
const Value = styled_components_1.default.text.withConfig({ displayName: "reports-Value", componentId: "reports-19lq0iv" }) `
  font-family: 'postgrotesk', 'Averta', 'Helvetica', sans-serif;
  font-weight: bold;
  font-size: 52px;
`;
const Kid = styled_components_1.default.div.withConfig({ displayName: "reports-Kid", componentId: "reports-18l61vl" }) `
  margin: auto;
  max-width: 60%;
  text-align: center;
`;
/**
 * The Arc component summarizes a part of a report. It may also link to details within the report
 */
exports.ValueArc = (0, styled_components_1.default)((_a) => {
    var _b, _c, _d;
    var { displayValues, value, min = 0, max = 100, children, status, labelsBelow = false } = _a, props = __rest(_a, ["displayValues", "value", "min", "max", "children", "status", "labelsBelow"]);
    const val = (0, in_range_1.default)({ max, min })(Number(value)) ? Number(value) : NaN; // value could be a string (e.g. '-') so we need to cast it to a Number to do math operations on it.
    const percentage = Math.max(0, Math.min(1, (val - min) / (max - min)));
    const angle = percentage * 180;
    const vHeight = 130;
    const vWidth = 230;
    const offsetX = 15;
    const offsetY = 15;
    return (react_1.default.createElement(ArcReactor, Object.assign({}, props),
        react_1.default.createElement(ArcWrapper, { "$labelsBelow": labelsBelow },
            react_1.default.createElement(Min, { "$labelsBelow": labelsBelow }, (_b = displayValues === null || displayValues === void 0 ? void 0 : displayValues.min) !== null && _b !== void 0 ? _b : min),
            react_1.default.createElement(ArcSVG, { viewBox: `0 0 ${vWidth} ${vHeight}`, xmlns: "http://www.w3.org/2000/svg", status: status, "$displayValues": displayValues },
                react_1.default.createElement(Value, { x: vWidth / 2, y: vHeight / 2 + 7, dominantBaseline: "middle", textAnchor: "middle", "data-testid": "arcValue" }, (_c = displayValues === null || displayValues === void 0 ? void 0 : displayValues.value) !== null && _c !== void 0 ? _c : value),
                react_1.default.createElement(ArcBase, { degrees: 180, color: base_react_components_1.theme.neutral300, vHeight: vHeight, vWidth: vWidth, offsetX: offsetX, offsetY: offsetY }),
                !isNaN(val) && (react_1.default.createElement(ArcFill, { degrees: angle, vHeight: vHeight, vWidth: vWidth, offsetX: offsetX, offsetY: offsetY })),
                !isNaN(val) && (react_1.default.createElement(ArcKnob, { degrees: angle, vHeight: vHeight, vWidth: vWidth, offsetX: offsetX, offsetY: offsetY }))),
            react_1.default.createElement(Max, { "$labelsBelow": labelsBelow }, (_d = displayValues === null || displayValues === void 0 ? void 0 : displayValues.max) !== null && _d !== void 0 ? _d : max)),
        react_1.default.createElement(Kid, null, typeof children === 'string' ? react_1.default.createElement(base_react_components_1.Header, { size: "md" }, children) : children)));
}).withConfig({ displayName: "reports-ValueArc", componentId: "reports-hwrx33" }) ``;
//# sourceMappingURL=index.js.map